import * as React from 'react';
import ProgressBar from 'design-system/ProgressBar';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system/values';
import { interpolate } from 'utils';
const RowAccountGoalProgress = ({ accountId, pot, containerStyles, }) => {
    const colors = useColors();
    const goal = useAppSelector((store) => accountId ? store.accounts?.goals?.[accountId] : undefined);
    const { isUnlocked } = useShouldShowUpgrade({
        benefitId: 'savingGoals',
    });
    let percent;
    if (goal) {
        percent = goal.percentageProgress;
    }
    else if (pot?.goal) {
        percent = interpolate(pot.balance.value, {
            inputRange: [0, pot.goal.amount],
            outputRange: [0, 100],
        });
    }
    if (!isUnlocked || percent === undefined) {
        return null;
    }
    return (<View style={[styles.container, containerStyles]}>
      <ProgressBar position={percent} colors={colors.gradients.ultimate.colors}/>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        paddingTop: rem(8),
        paddingLeft: rem(16),
        paddingBottom: rem(4),
    },
});
export default React.memo(RowAccountGoalProgress);
